import { useContext } from 'react';
import { ThemeContext } from 'src/contexts/Theme';

const useTheme = () => {
  return useContext(ThemeContext);
};

export default useTheme;
